/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import PostInserterConfiguration from 'embercom/objects/series/node/post-inserter-configuration';

export default class PostNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new PostInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
